import axios from 'axios';
import _ from 'lodash';
import { alertMsg, ResponseCommCodeEnum } from '../commlogic';
import { EHAND_API_URL, EQUIPMENT_API_URL, SYS_API_URL, BS_API_URL, DUTY_API_URL, PATIENT_SURVEY_API_URL, TIMEOUT } from '../../comm/config';
import { LOGIN_INFO } from '../../comm/constant';
import { i18n } from '../../language';
import { store } from '../../redux';
import { LOADING_HIDE, LOADING_SHOW } from '../../redux/constant';
import { getAuthToken, getEhandoverHeaderParams } from '../../utils';
import { checkToken, tokenInvalid, userInActive } from '../../utils/check';
import throttleUrlMap from '../../comm/throttleUrlMap';
import errorCodeMapping from '../teleVisit/errorCodeMapping';
const AxiosRequestConfig = {
  timeout: TIMEOUT,
};

const instance = axios.create(AxiosRequestConfig);

instance.defaults.headers.post['Content-Type'] = 'text/plain; charset=utf-8;';

let count = 0;
// 创建一个 Map 来存储每个 URL 的节流函数
const throttleMap = new Map();

const EHANDOVER_API_HOST = EHAND_API_URL;
const EQUIPMENT_API_HOST = EQUIPMENT_API_URL;
const SYSTEM_API_HOST = SYS_API_URL;
const BED_STATUS_API_HOST = BS_API_URL;
const DUTY_API_HOST = DUTY_API_URL;
const PATIENT_SURVEY_API_HOST = PATIENT_SURVEY_API_URL;

const hideLoading = () => {
  if (count <= 0) return;
  count--;
  if (count === 0) {
    store.dispatch({ type: LOADING_HIDE });
  }
};

const showLoading = () => {
  if (count === 0) {
    store.dispatch({ type: LOADING_SHOW });
  }

  count++;
};

const errorControlClass = () => {
  let count = {};
  const hide = (key) => {
    if (isShow(key)) {
      count[key] = count[key] - 1;
    }
  };
  const show = (key ) => {
    count[key] = count?.[key] ?? 0 + 1;
  };
  const isShow = ( key ) => {
    return (count?.[key] ?? 0) > 0;
  };
  const alert = (key, msg, ID, type = 'error', timeout = null, autoClose = true) => {
    if(isShow(key)){
      alertMsg(msg, ID, type, timeout, autoClose);
      hide();
    }
  }
  return {
    hide,
    show,
    isShow,
    alert
  };
};
let errorControl = errorControlClass();

const getAuthorization = () => {
  const Authorization = getAuthToken();
  if (Authorization) {
    return { Authorization };
  } else {
    return {};
  }
};

const checkTokenFn = async (response) => {
  const invalidTokenHandling = () => {
    const currentState = store.getState();
    const expiryLoginState = currentState.expiryLogin;
    if (!expiryLoginState.isOpen) {
      tokenInvalid(false);
      errorControl.alert(
        response.config.url,
        i18n.t('ALERT_IDLE_DETECTED_YOU_ARE_SIGNED_OUT_BECAUSE_OF_SECURITY_CONCERN'),
        _.uniqueId('warning_'),
        'warning'
      );
    }
  };

  const result = await checkToken(true, true);
  if (result) {
    try {
      const login = localStorage.getItem(LOGIN_INFO);
      const { token } = JSON.parse(login);
      const oldHeaders = response.config.headers;
      const newHeaders = { ...oldHeaders, Authorization: token ?? '' };
      return { success: true, response: await instance({ ...response.config, headers: newHeaders }) };
    } catch (error) {
      if (ResponseCommCodeEnum.USER_INACTIVE === (error?.statusCode ?? '')) {
        invalidTokenHandling();
      }
      return { success: false, response: error };
    }
  } else {
    invalidTokenHandling();
    return { success: false };
  }
};

function readBlob(blob) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}

// 节流函数的工具方法
const getThrottledRequest = (url) => {
  if (!throttleMap.has(url)) {
    // 如果该 URL 没有节流函数，则创建一个新的节流函数存入 Map
    const throttled = _.throttle((resolve, config) => resolve(config), TIMEOUT);
    throttleMap.set(url, throttled);
  }
  return throttleMap.get(url);
};

instance.interceptors.request.use(
  (config) => {
    if (!config.headers?.isHideLoading) {
      showLoading();
    } else {
      count++;
    }

    if (!config.headers?.isHideError) {
      errorControl.show(config.url);
    }

    let logHeaders = {};
    if (config.url.startsWith(EHANDOVER_API_HOST) && config.url.indexOf('/task/export') === -1) {
      logHeaders = getEhandoverHeaderParams(config.url, EHANDOVER_API_HOST);
    } else if (config.url.startsWith(EQUIPMENT_API_HOST)) {
      logHeaders = getEhandoverHeaderParams(config.url, EQUIPMENT_API_HOST);
    } else if (config.url.startsWith(SYSTEM_API_HOST)) {
      logHeaders = getEhandoverHeaderParams(config.url, SYSTEM_API_HOST);
    } else if (config.url.startsWith(BED_STATUS_API_HOST)) {
      logHeaders = getEhandoverHeaderParams(config.url, BED_STATUS_API_HOST);
    } else if (config.url.startsWith(DUTY_API_HOST)) {
      logHeaders = getEhandoverHeaderParams(config.url, DUTY_API_HOST);
    } else if (config.url.startsWith(PATIENT_SURVEY_API_HOST)){
      logHeaders = getEhandoverHeaderParams(config.url, PATIENT_SURVEY_API_HOST);
    }

    config.headers = {
      ...config.headers,
      ...getAuthorization(),
      ...logHeaders,
    };

    if (config.headers?.isHideLoading !== undefined) {
      delete config.headers['isHideLoading'];
    }

    if (config.headers?.isHideError !== undefined) {
      delete config.headers['isHideError'];
    }

    if (_.some(throttleUrlMap, (item) => config.url.includes(item))) {
      // 获取该 URL 的节流函数
      const throttleRequest = getThrottledRequest(config.url);

      // 返回一个新的 Promise，让节流函数控制 config 的传递时机
      return new Promise((resolve) => {
        throttleRequest(resolve, config);
      });
    } else {
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
const errorMessageFun = (url, statusCode) => {
  let text;
  Object.keys(errorCodeMapping.errorMessage).forEach((key) => {
    if (key === statusCode) {
      text = errorCodeMapping.errorMessage[key];
    }
  });
  return errorControl.alert(url, i18n.t(text), _.uniqueId('error_'));
};

instance.interceptors.response.use(
  async (response) => {
    hideLoading();
    const url = response.config.url;
    const interAlertMsg = (msg, ID, type) => {
      errorControl.alert(url, msg, ID, type);
    };
    throttleMap.delete(response.config.url);

    if (Object.prototype.toString.call(response.data) === '[object Blob]') {
      let blobContent = await readBlob(response.data);
      try {
        response.data = JSON.parse(blobContent);
      } catch (error) {
        return response;
      }
    }

    // CHECK_SERVER 报错的时候放在外部处理
    if (
      response.data.statusCode === ResponseCommCodeEnum.SUCCESS ||
      response.data.statusCode === ResponseCommCodeEnum.CHECK_SERVER
    ) {
      return response.data;
    } else if (response.data.statusCode === ResponseCommCodeEnum.TOKEN_ERROR) {
      let recallResult = await checkTokenFn(response);
      if (!recallResult.success) {
        return Promise.reject(response.data);
      }
      return recallResult.response;
    } else if (response.data.statusCode === ResponseCommCodeEnum.USER_INACTIVE) {
      userInActive(false);
      interAlertMsg(i18n.t('ALERT_ACCOUNT_EXCEPTION_PLEASE_TRY_TO_LOGIN_AGAIN'), _.uniqueId('warning_'), 'warning');
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.BED_VERSION) {
      return Promise.reject(response.data);
    } else if (errorCodeMapping.errorCode.includes(Number(response.data.statusCode))) {
      errorMessageFun(url, response.data.statusCode);
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.ADS_SERVICE_EXCEPTION) {
      interAlertMsg(response.data.statusMessage, _.uniqueId('warning_'), 'warning');
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.DUTYASSIGN_UPLOADED_FAIL) {
      interAlertMsg(i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_FAIL_HAVE_ERRORS_MESSAGE'), _.uniqueId('error_'));
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.DUTYASSIGN_UPLOADED_ERROR) {
      interAlertMsg(i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_ERROR_NO_RECORD_MESSAGE'), _.uniqueId('error_'));
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.DUTYASSIGN_UPLOADED_NO_CORPID) {
      interAlertMsg(i18n.t('DUTY_ASSIGN_UPLOAD_DIALOG_UPLOADED_SUCCESS_NO_CORPID_MESSAGE'), _.uniqueId('error_'));
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.EQUIPMENT_DUPLICATE_REQUEST) {
      interAlertMsg(i18n.t('EQUIPMENT_DUPLICATE_REQUEST_ERROR'), _.uniqueId('error_'));
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.SCAN_HKID) {
      interAlertMsg(i18n.t('EQUIPMENT_SCAN_HKID_NOT_FOUND_ERROR'), _.uniqueId('error_'));
      return Promise.reject(response.data);
    } else if (response.data.statusCode === ResponseCommCodeEnum.EHD_HA_CHAT_MESSAGE_STILL_SENDING) {
      interAlertMsg(i18n.t('EHANDOVER_HA_CHAT_MESSAGE_STILL_SENDING'), _.uniqueId('error_'));
      return Promise.reject(response.data);
    }else {
      if (!response.config.url.includes('/corpId/verify')) {
        setTimeout(() => {
          interAlertMsg(response.data.statusMessage, _.uniqueId('error_'));
        }, 500);
      }
      return Promise.reject(response.data);
    }
  },
  (error) => {
    if (error.config && error.config.url) {
      throttleMap.delete(error.config.url);
    }
    hideLoading();
    let url = error.config.url;
    setTimeout(() => {
      errorControl.alert(url,i18n.t('ALERT_NETWORK_ERROR'), _.uniqueId('error_'));
    }, 300);
    return Promise.reject(error);
  }
);

/**
 * Simple Http Client
 * @param {string} method
 * @param {string} url
 * @param {object} param
 * @param {object} AxiosConfig see https://github.com/axios/axios#request-config
 */
const httpClient = (method, url, params, AxiosConfig) => {
  let httpConfig = {};
  httpConfig = {
    method,
    url,
    params: method === 'get' || method === 'delete' ? params : null,
    data: method === 'post' ? params : null,
    ...AxiosConfig,
  };
  return new Promise((resolve, reject) => {
    instance(httpConfig)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const AxiosInstance = instance;

export default {
  /**
   * @param {string} url
   * @param {object} params optional
   * @param {object} AxiosConfig optional see https://github.com/axios/axios#request-config
   */
  post(url, params = null, AxiosConfig = null) {
    return httpClient('post', url, params, AxiosConfig);
  },

  /**
   * @param {string} url
   * @param {object} params optional
   * @param {object} AxiosConfig optional https://github.com/axios/axios#request-config
   */
  get(url, params = null, AxiosConfig = null) {
    return httpClient('get', url, params, AxiosConfig);
  },

  delete(url, params = null, AxiosConfig = null) {
    return httpClient('delete', url, params, AxiosConfig);
  },
};

export { getAuthorization };
